import { emailValidation, passwordValidation } from "@/constants/schema";
import { object } from "yup";

export const changeEmailSchema = object({
    newEmail: emailValidation,
    currentEmail: emailValidation,
    password: passwordValidation,
});
